import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AdminAuthService } from './services/auth/admin-auth.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IdleCountdownDialogComponent } from 'reg-hub-common';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { idleTimers } from '../environments/environment';
import { MatIconRegistry } from '@angular/material/icon';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent {
  title = 'reg-hub-admin';

  isSidenavOpen = true;

  protected isAuthenticated: boolean = false;

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = undefined;
  countdown: number = 0;
  dialogRef: MatDialogRef<IdleCountdownDialogComponent> | null = null;

  constructor(
    private authService: AdminAuthService,
    private router: Router,
    private idle: Idle,
    private dialog: MatDialog,
    private matIconRegistry: MatIconRegistry) {
      idle.setIdle(idleTimers.idleTimeoutInSeconds);
      idle.setTimeout(idleTimers.logoutWarningCountdownInSeconds);
      // Set default interrupts (e.g., mouse, keyboard, touch)
      idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

      // Subscribe to idle events
      idle.onIdleEnd.subscribe(() => {
        this.idleState = 'No longer idle.';
        this.resetIdleTimer();
        this.closeDialog();
      });

      idle.onTimeout.subscribe(() => {
        this.idleState = 'Timed out!';
        this.timedOut = true;
        this.authService.logOut();
      });

      idle.onIdleStart.subscribe(() => this.idleState = "You've gone idle!");
      idle.onTimeoutWarning.subscribe((countdown) => {
        this.countdown = countdown;
        this.openOrUpdateIdleCountdownDialog(countdown);
      });
    }

  ngOnInit(): void {
    this.matIconRegistry.setDefaultFontSetClass('material-symbols-rounded');

    this.resetIdleTimer();
    this.authService.completeAuthentication().then(() => {  
      this.isAuthenticated = true;
    })
    .catch(() => {
      if (!this.authService.isLoggedIn() && !this.router.url.startsWith("/callback")) {
        this.authService.logIn()
      } else {
        this.isAuthenticated = true;
      }
    });
  }

  resetIdleTimer(): void {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  openOrUpdateIdleCountdownDialog(countdown: number): void {
    if (this.dialogRef) {
      // Dialog is already open, update countdown
      this.dialogRef.componentInstance.data.countdown = countdown;
    } else {
      // Open a new dialog
      this.dialogRef = this.dialog.open(IdleCountdownDialogComponent, {
        width: '300px',
        data: { countdown }
      });

      this.dialogRef.afterClosed().subscribe(() => {
        this.dialogRef = null;
        this.resetIdleTimer();
      });
    }
  }

  closeDialog(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      this.dialogRef = null;
    }
  }
}
